import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import store from '@lib/store/configuration';
import FieldExtensions from '../edit-page/fields/FieldExtensions';
import Card from '../edit-page/Card';
import IconEdit from '../icons/IconEdit';
import IconAccept from '../icons/IconAccept';

const EditorCommentCard = observer(
    class EditorCommentCard extends React.Component {


        state = {
            commentValue: '',
            editable: false
        }

        onButtonEditClick = field => {
            var newEditable = _.xor(this.state.editable, [field.slug]);
            configurationStore.generalInformationDuringEdit = newEditable.length > 0;

            this.setState({
                editable: newEditable
            })
        }

        renderField = (field, possibleToEdit) => {
            return renderField(field, this.state.editable.includes(field.slug), possibleToEdit, this.onButtonEditClick, '', () => {
            });
        }

        constructor(props) {
            super(props);

            this.state = {
                commentValue: store.formModel.generalInformation.comment.value || ''
            }
        }

        render() {
            return (
                <Card
                    label="Comment"
                    className="editor-comment-card"
                    helpInfo={store.formModel.commentHelpInfo.value}
                    // editableMode={store.editableMode}
                    // editable={store.commentDuringEdit}
                    onEditButtonClick={this.onEditButtonClick}>
                    {this.renderComment()}
                </Card>
            )
        }

        renderComment = () => {
            const classes = [];
            if (!this.state.editable) {
                classes.push('read-only')
            }

            return (
                <div style={{display: 'flex'}}>
                    <textarea
                        className={classes.join(' ')}
                        //readOnly={!store.commentDuringEdit}
                        value={this.state.commentValue}
                        onChange={this.onCommentChanged}
                    />
                    {this.state.editable && (
                        <div style={{marginLeft: '10px'}}>
                            <div onClick={() => {
                                this.setState({editable: false});
                                store.formModel.generalInformation.comment.value = this.state.commentValue;
                                store.setCommentDuringEdit(false);
                            }}>
                                <IconAccept/>
                            </div>
                        </div>
                    )}
                    {(!this.state.editable && store.editableMode) && (
                        <div style={{marginLeft: '10px'}}>
                            <div onClick={() => {
                                this.setState({editable: true});
                                store.setCommentDuringEdit(true);
                            }}>
                                <IconEdit/>
                            </div>
                        </div>
                    )}
                </div>

            )

        }

        onCommentChanged = e => {
            this.setState({
                commentValue: e.target.value
            })
        }

        onEditButtonClick = () => {
            store.formModel.generalInformation.comment.value = this.state.commentValue;
            store.setCommentDuringEdit(!store.commentDuringEdit);
        }
    }
)

export default EditorCommentCard